// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/lib/components/menu/menu-trigger/menu-trigger-button.component.scss
// module id = 218
// module chunks = 0